import _ from 'lodash';
import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import DocumentModal from './document-modal';
import HFMDragDropContext from 'common/components/hfm-drag-drop-context';

export default class FAQList extends React.Component {
// export default ({  }) => {
	render () {
		const { documentStore, active = 'ARTIST_FAQ' } = this.props;
		// if (_.isEmpty(member.subscribedTo)) {

		// 	return (
		// 		<em>No subscriptions</em>
		// 	);
		// }
		// console.log("this.state.active")
		// console.log(documentStore.documents)
		// console.log(documentStore.testDocuments)

		// for (let doc in documentStore.documents) {
		// 	console.log(documentStore.documents[doc].content)
		// }

		// for (let doc in documentStore.testDocuments) {
		// 	console.log(documentStore.testDocuments[doc].content)
		// }


		return (
			<Fragment>
				<DocumentModal buttonLabel="New FAQ" icon="plus" documentType={ active }/>


				<div className="cell small-7">
					<HFMDragDropContext
						// dragDropList={ documentStore.testDocuments }
						// dragDropList={ documentStore.documents }

						
						// dragDropList={ _(_.filter(documentStore.documents, {type: active})).sortBy('orderIndex').value() }
						dragDropList={ _(_.filter(documentStore.testDocuments, {type: active})).sortBy('orderIndex').value() }

						// dragDropList={ 
						// 	_.map(documentStore.testDocuments, function(doc) {
						// 		console.log(doc.type)
						// 		if (doc.type == active) return doc;
						// 	})
						// }
						onDragEnd={ this.props.onDragEnd }
						ItemLabel={ this.renderLabel }
						ItemButton={ this.renderRemoveButton } 
					/>
				</div>
			</Fragment>
		);
	}

	@autobind
	getDocumentsByType (store, type) {

	}

	@autobind
	renderRemoveButton ({ _id }) {
		return (
			<button
				key={ _id }
				data-id={ _id }
				onClick={ this.removeItem }
				className="button secondary clear margin-bottom-0">
					<span className="fas fa-minus"></span>
			</button>
		);
	}

	@autobind
	renderLabel (document) {
		return (
			<div className="grid-x"> 
				
				<div className="cell small-1">
					<DocumentModal
						document={ document }
						buttonClassName="button clear secondary padding-left-0"
					/>
				</div>
				
				<div className="cell small-11"> 
					<b>{ document.title }</b>
					<br />
					<p>{ (document.content.length > 256 ? (document.content.substring(0,256) + "...") : document.content) }</p>
				</div>

			</div>
		);
	}	
};

